import { useState } from 'react';

import DropdownArrowIcon from '@/assets/all-icons/dropdown-arrow-icon';
import ToggleSwitch from '@/shared-components/toggles/ToggleSwitch';

export default function NotificationPreferenceSection({
  essential,
  enabled,
  events,
  id,
  onEventChange,
  onSectionChange,
  preferences,
  saving,
  t,
  title
}) {
  const [isOpen, setIsOpen] = useState(false);
  const detailsId = `notification-preference-${id}-details`;

  return (
    <section
      className={`notification-preferences__section${isOpen ? ' is-open' : ''}`}
      aria-labelledby={`notification-preference-${id}`}
    >
      <div className="notification-preferences__section-header">
        <div className="notification-preferences__section-left">
          <button
            type="button"
            className={`notification-preferences__dropdown-button${isOpen ? ' is-open' : ''}`}
            aria-controls={detailsId}
            aria-expanded={isOpen}
            aria-label={title}
            onClick={() => setIsOpen((open) => !open)}
          >
            <span aria-hidden="true">
              <DropdownArrowIcon
                className={`notification-preferences__dropdown-icon${isOpen ? ' is-open' : ''}`}
              />
            </span>
          </button>
          <h3 id={`notification-preference-${id}`} className="notification-preferences__section-title">
            {title}
          </h3>
        </div>
        {essential ? (
          <span className="notification-preferences__essential-label">{t('essential')}</span>
        ) : (
          <ToggleSwitch
            ariaLabel={title}
            checked={enabled}
            disabled={saving}
            onChange={onSectionChange}
          />
        )}
      </div>
      <div
        id={detailsId}
        className={`notification-preferences__section-details${isOpen ? ' is-open' : ''}`}
      >
        <ul className="notification-preferences__event-list">
          {events.map((eventId) => (
            <li className="notification-preferences__event" key={eventId}>
              <span className="notification-preferences__event-label">
                {t(`sections.${id}.events.${eventId}`)}
              </span>
              {essential ? (
                <span className="notification-preferences__essential-event">{t('essential')}</span>
              ) : (
                <ToggleSwitch
                  ariaLabel={t(`sections.${id}.events.${eventId}`)}
                  checked={preferences[eventId] === true}
                  disabled={saving}
                  onChange={(nextValue) => onEventChange(eventId, nextValue)}
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
